// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DzvT","col":"styles_col__28PPl"};